import { format as formatFn, isValid as isValidFn, formatDistance as formatDistanceFn, parse, } from 'date-fns';
import { DATE_FORMAT, FULL_DATE_TIME_FORMAT, SERVER_DATE_FORMAT, TIME_FORMAT, KYC_DATE_FORMAT } from './DATE_FORMAT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isValid = (date) => isValidFn(date);
export const format = (date, formatString) => {
    if (!date)
        return '';
    const dateObj = new Date(date);
    return isValid(dateObj) ? formatFn(dateObj, formatString) : '';
};
export const formatDateTime = (date) => {
    return format(date, `${DATE_FORMAT} - ${TIME_FORMAT}`);
};
export const formatDate = (date) => {
    return format(date, KYC_DATE_FORMAT);
};
export const formatTime = (date) => {
    return format(date, TIME_FORMAT);
};
export const formatFullDateTime = (date) => {
    return format(date, FULL_DATE_TIME_FORMAT);
};
export const formatDistance = (date) => {
    if (!date)
        return date;
    const dateObj = new Date(date);
    return isValid(dateObj)
        ? formatDistanceFn(dateObj, new Date(), { addSuffix: true })
        : '';
};
export const parseServerDate = (dateString) => {
    if (!dateString)
        return dateString;
    return parse(dateString, SERVER_DATE_FORMAT, new Date());
};
